import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const maintenanceApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMaintenanceListById: builder.query<any, {id:string,page:number,args:any}>({
            query: ({id,page,args}) => `/Station/${id}/maintenance?page=${page}`.concat(generateFormatedURL(args)),
        }),
        getMaintenanceById: builder.query<any, string>({
           query: (id) => `/Maintenance/${id}`
        }),

        updateMaintenance: builder.mutation({
            query: (formData) => {
                //console.log(stationId);
                return {
                    url: "/Maintenance",
                    method: "PUT",
                    body: formData,
                }
            }
        }),
    })
})

export const {
    useLazyGetMaintenanceListByIdQuery,
    useLazyGetMaintenanceByIdQuery,
    useUpdateMaintenanceMutation,
} = maintenanceApiSlice;